<!--
@create date 2023-6-26
@desc S821.phomemo.com
-->
<template>
  <div class="guides-div">
    <div class="topText">
      <h1>Download for Phomemo S821 Portable Printer</h1>
    </div>
    <!--   <hr style="color: rgba(51, 61, 71,0.3);width: 30%;margin-bottom: 50px;" v-show="!isMobile()" /> -->
    <div class="main-contain">
      <!--     phone -->
      <div class="item-margin" v-show="isMobile()">
        <div style="margin-bottom: 40px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'S821_appDownload' });
                window.open('https://downloadapp.qu-in.life/MrIn-Phomemo/');
              }
            "
            class="a-link"
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="S821_APPVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/phomemo-s821wifi.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
      </div>
      <!--     windows -->
      <div class="item-margin">
        <div style="margin-bottom: 22px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'S821_windowsDrivers' });
                window.open(
                  'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN_EN.zip'
                );
              }
            "
            class="a-link"
            >Driver for Windows</a
          >
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="S821_windowsVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
      </div>

      <div class="item-margin">
        <div style="margin-bottom: 22px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/windows-phone-logo-topic.png?v=1644832318"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'S821_ARMDrivers' });
                window.open(
                  'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_WIN-ARM_EN.zip'
                );
              }
            "
            class="a-link"
            style="line-height: 26px; font-size: 16px"
            >Driver for Windows(ARM)</a
          >
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="S821_windowsVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_win_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3); margin-top: 40px"
          v-show="isMobile()"
        />
      </div>

      <!--     mac -->
      <div class="item-margin">
        <div style="margin-bottom: 28px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/2235.png?v=1644832141"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'S821_macDrivers' });
                window.open(
                  'https://oss.qu-in.club/Tianyi/QY_Printer_Driver_MAC_EN.zip'
                );
              }
            "
            class="a-link"
            >Driver for Mac</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 88%"
            id="S821_macVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/p831_mac_guide.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!-- Linux -->
      <div class="item-margin">
        <div style="margin-bottom: 14px">
          <img
            src="https://cdn.shopify.com/s/files/1/0180/9294/9568/files/pm246sLinux.png?v=1688530177"
            style="
              display: block;
              margin: 10px auto;
              width: 100px;
              height: 110px;
            "
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'S821_linuxDrivers' });
                window.open(
                  'https://oss.qu-in.life/Tianyi/QY_Printer_Driver_Linux_EN.zip'
                );
              }
            "
            class="a-link"
            >Driver for Linux</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            style="width: 100%"
            id="S821_linuxVideo"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/pm246s_linux.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
        <hr
          style="color: rgba(51, 61, 71, 0.3)"
          v-show="!isMobile()"
          class="hrDivEx"
        />
      </div>
      <!--     phone -->
      <div class="item-margin" v-show="!isMobile()">
        <div style="margin-bottom: 22px">
          <img
            src="https://cdn.shopifycdn.net/s/files/1/0180/9294/9568/files/app.png?v=1654666291"
            style="display: block; margin: 10px auto; width: 100px"
          />
          <a
            @click="
              () => {
                refreshRecord({ key: 'S821_appDownload' });
                window.open('https://downloadapp.qu-in.life/MrIn-Phomemo/');
              }
            "
            class="a-link"
            >App for Smart Phone</a
          ><br />
        </div>
        <div class="video-contain">
          <video
            controls
            webkit-playsinline="true"
            class="video"
            id="S821_APPVideo_2"
          >
            <source
              src="https://oa.aimotech.cn/phomemo/pm246s/phomemo-s821wifi.mp4"
              type="video/mp4"
            />
            您的浏览器不支持 HTML5 video 标签。
          </video>
        </div>
      </div>
    </div>
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 54%; margin-bottom: 40px"
      v-show="!isMobile()"
    />
    <hr
      style="color: rgba(51, 61, 71, 0.3); width: 100%; margin-bottom: 40px"
      v-show="isMobile()"
    />
    <div class="customService" style="margin-top: 10px">
      <h1>Quick Start Guide</h1>
      <div>
        <a
          style="color: #1fc3ff; text-decoration: auto"
          @click="
            () => {
              refreshRecord({ key: 'S821_quickStartGuide' });
              window.open(
                'https://doc.labelife.net/upload/video/phomemo/NeutralS821InstructionManual.pdf'
              );
            }
          "
          target="_blank"
          >Click Here for A Quick Start Guide</a
        >
      </div>
    </div>
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 54%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="!isMobile()"
    />
    <hr
      style="
        color: rgba(51, 61, 71, 0.3);
        width: 100%;
        margin: 45px auto;
        margin-top: 25px;
      "
      v-show="isMobile()"
    />
    <div class="customService">
      <h1>Customer Service</h1>
      <div class="everyRow">
        Email：<a
          @click="
            () => {
              refreshRecord({ key: 'S821_email' });
              window.open('mailto:support@phomemo.com');
            }
          "
          >support@phomemo.com</a
        >
      </div>
      <div class="everyRow">Tel：+1 855 957 5321(US ONLY)</div>
      <div class="everyRow">Whatsapp：+86 15338193665</div>
    </div>
  </div>
</template>

<script>
const isMobile = () => {
  // 返回true为移动端，否则为pc端
  if (!window.navigator) return true;
  const flag = window.navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag ? true : false;
};
import { refreshRecord, sensorsRecord } from "@/util.js";
export default {
  name: "P831",
  props: {},
  data() {
    return {
      window,
      activeQuestion2: {},
      isMobile,
      refreshRecord,
    };
  },
  mounted() {
    this.listenVideo("S821_macVideo");
    this.listenVideo("S821_windowsVideo");
    this.listenVideo("S821_linuxVideo");
    this.listenVideo("S821_APPVideo");
    this.listenVideo("S821_APPVideo_2");
    sensorsRecord({ key: "S821_view" }, 1);
    sensorsRecord({ key: "S821_WebStay" }, 3);
  },
  methods: {
    listenVideo(videoId) {
      document.getElementById(videoId).addEventListener("play", function () {
        // console.log("视频开始播放了！");
        refreshRecord({
          key: videoId === "S821_APPVideo_2" ? "S821_APPVideo" : videoId,
        });
      });
    },
    clickQuestion2(item = {}, index) {
      const { activeQuestion2 } = this;
      if (
        activeQuestion2.index === undefined ||
        activeQuestion2.index !== index
      ) {
        this.activeQuestion2 = { ...item, index };
      } else this.activeQuestion2 = {};
    },
  },
};
</script>

<style lang="less" src="./style.less" />



// WEBPACK FOOTER //
// src/view/guides/s821.vue